import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { CSSTransition } from "react-transition-group";

export default function SwatchToast({ message, setMessage }) {
  const [currentMessage, setCurrentMessage] = useState(null);
  const nodeRef = useRef();
  // useEffect(() => {
  //   if (!message) return;
  //   setTimeout(() => {
  //     setMessage(null);
  //   }, 3000);
  // }, [message]);

  return (
    <CSSTransition
      in={!!message}
      nodeRef={nodeRef}
      timeout={400}
      classNames="pdp-swatch-modal__toast-"
      mountOnEnter={true}
      unmountOnExit={true}
      onEnter={() => setCurrentMessage(message)}
      onEntered={() =>
        setTimeout(() => {
          setMessage(null);
        }, 1500)
      }
      onExited={() => setCurrentMessage(null)}
    >
      <div ref={nodeRef} className="pdp-swatch-modal__toast">
        {currentMessage}
      </div>
    </CSSTransition>
  );
}
